import {all, call, put, takeLatest} from '@redux-saga/core/effects';
import {goBack} from 'connected-react-router';
import {createSnackbar} from 'Core/ducks/snackbar';
import {AsyncResult} from 'Core/models/Async';
import * as E from 'fp-ts/lib/Either';
import {savePolicyServiceRequest} from 'Agent/Policies/api/policyServiceRequestApi';
import {
  PolicyServiceRequestActionType,
  savePolicyServiceRequest as savePolicyServiceRequestAction,
} from 'Agent/Policies/ducks/policyServiceRequest';

export function* saveServiceRequestApi(action: ReturnType<typeof savePolicyServiceRequestAction>) {
  const result: AsyncResult<unknown> = yield call(
    savePolicyServiceRequest,
    action.payload.encryptedIdentifier,
    action.payload.serviceRequest
  );

  if (E.isRight(result)) {
    yield put(createSnackbar('Policy Service Request Submitted'));
    yield put(goBack());
  } else {
    yield put(createSnackbar('An Error Ocurred While Sending the Service Request. Please Try Again.'));
  }
}

export function* saveServiceRequestSaga() {
  yield takeLatest(PolicyServiceRequestActionType.SAVE_SERVICE_REQUEST, saveServiceRequestApi);
}

export default function*() {
  yield all([saveServiceRequestSaga()]);
}
